(() => {
  const mobileMedia = window.matchMedia('(max-width: 768px)');
  const rowSelector = '[data-vnm-recommendation-row]';
  const labelSource = document.querySelector('[data-vnm-recommendation-labels]');
  const defaultLabels = {
    addToCart: 'Toevoegen',
    chooseOptions: 'Kies mogelijkheden',
    inStock: 'Op voorraad',
    soldOut: 'Binnenkort weer op voorraad',
    quantity: 'Aantal',
    close: 'Sluiten',
    error: 'Er is een fout opgetreden.',
    addedToCart: 'Item toegevoegd aan je winkelwagen.'
  };
  let labels = defaultLabels;
  let activeSheet;
  let toastTimer;
  let syncTimer;
  let syncInFlight;

  try {
    labels = { ...defaultLabels, ...JSON.parse(labelSource?.textContent || '{}') };
  } catch (error) {
    labels = defaultLabels;
  }

  const routes = () => ({
    cart: window.theme?.routes?.cart || '/cart',
    cartAdd: window.theme?.routes?.cartAdd || '/cart/add.js',
    cartChange: window.theme?.routes?.cartChange || '/cart/change.js'
  });

  const silentUrl = (url) => `${url}${url.includes('?') ? '&' : '?'}sc-silently-change-cart=true`;
  const rows = () => Array.from(document.querySelectorAll(rowSelector));
  const optionValues = (variant = {}) => {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter((option) => option != null);
  };
  const optionText = (variant) => optionValues(variant).filter(Boolean).join(' · ');
  const formatMoney = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR'
  }).format(Number(amount || 0) / 100);
  const getProduct = (row) => {
    const source = row.querySelector('[data-vnm-recommendation-product]');
    if (!source) return null;
    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      return null;
    }
  };
  const cartItem = (cart, row, allowProductVariantFallback = true) => {
    const items = cart?.items || [];
    const selectedVariantId = Number(row.dataset.variantId);
    const selectedItem = items.find((item) => Number(item.variant_id) === selectedVariantId);
    if (selectedItem || !allowProductVariantFallback) return selectedItem;
    const product = getProduct(row);
    const productVariantIds = new Set((product?.variants || [])
      .map((variant) => Number(variant?.id))
      .filter((variantId) => Number.isFinite(variantId)));
    return items.find((item) => productVariantIds.has(Number(item.variant_id)));
  };
  const refreshQikify = () => {
    try {
      if (typeof window.STICKY_CART_UPDATE === 'function') window.STICKY_CART_UPDATE();
    } catch (error) {
      return;
    }
  };
  const updateCartIcon = (data) => {
    const content = data?.sections?.['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (!content || !bubble) return;
    const template = document.createElement('template');
    template.innerHTML = content.trim();
    const replacement = template.content.querySelector('#cart-icon-bubble');
    if (replacement) bubble.replaceWith(replacement);
    else bubble.innerHTML = content;
  };
  const loadCart = async () => {
    const response = await fetch(`${routes().cart}.js?_=${Date.now()}`, {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(String(response.status));
    return response.json();
  };
  const syncRows = (cart) => {
    rows().forEach((row) => {
      const item = cartItem(cart, row);
      const defaultAction = row.querySelector('[data-vnm-recommendation-default]');
      const controls = row.querySelector('[data-vnm-recommendation-controls]');
      const quantity = row.querySelector('[data-vnm-recommendation-quantity]');
      const decrementControl = row.querySelector('[data-vnm-recommendation-remove]');
      const trashIcon = decrementControl?.querySelector('[data-vnm-recommendation-remove-icon]');
      const minusIcon = decrementControl?.querySelector('[data-vnm-recommendation-decrease-icon]');
      if (!defaultAction || !controls || !quantity) return;
      if (item) {
        const itemQuantity = Math.max(1, Number(item.quantity) || 1);
        const isSingle = itemQuantity === 1;
        const quantityState = isSingle ? 'single' : 'multiple';
        row.dataset.variantId = String(item.variant_id);
        row.dataset.lineKey = item.key;
        row.dataset.quantityState = quantityState;
        defaultAction.hidden = true;
        controls.hidden = false;
        quantity.textContent = itemQuantity;
        if (decrementControl) {
          const removeLabel = decrementControl.dataset.removeLabel || 'Verwijder item';
          const decreaseLabel = decrementControl.dataset.decreaseLabel || 'Verminder aantal met 1';
          decrementControl.dataset.quantityState = quantityState;
          decrementControl.setAttribute('aria-label', isSingle ? removeLabel : decreaseLabel);
          decrementControl.removeAttribute('data-vnm-recommendation-quantity');
          if (trashIcon) {
            trashIcon.hidden = !isSingle;
            trashIcon.classList.toggle('is-hidden', !isSingle);
            trashIcon.setAttribute('aria-hidden', String(!isSingle));
          }
          if (minusIcon) {
            minusIcon.hidden = isSingle;
            minusIcon.classList.toggle('is-hidden', isSingle);
            minusIcon.setAttribute('aria-hidden', String(isSingle));
          }
        }
      } else {
        delete row.dataset.lineKey;
        row.dataset.quantityState = 'empty';
        defaultAction.hidden = false;
        controls.hidden = true;
        quantity.textContent = '1';
        if (decrementControl) {
          decrementControl.dataset.quantityState = 'empty';
          decrementControl.setAttribute('aria-label', decrementControl.dataset.removeLabel || 'Verwijder item');
          decrementControl.removeAttribute('data-vnm-recommendation-quantity');
          if (trashIcon) {
            trashIcon.hidden = false;
            trashIcon.classList.remove('is-hidden');
            trashIcon.setAttribute('aria-hidden', 'false');
          }
          if (minusIcon) {
            minusIcon.hidden = true;
            minusIcon.classList.add('is-hidden');
            minusIcon.setAttribute('aria-hidden', 'true');
          }
        }
      }
    });
  };
  const syncCurrentCart = async () => {
    if (!mobileMedia.matches || !rows().length) return null;
    if (syncInFlight) return syncInFlight;
    syncInFlight = loadCart()
      .then((cart) => {
        syncRows(cart);
        return cart;
      })
      .catch(() => null)
      .finally(() => {
        syncInFlight = undefined;
      });
    return syncInFlight;
  };
  const scheduleCartSync = (immediate = false) => {
    window.clearTimeout(syncTimer);
    if (immediate) return syncCurrentCart();
    syncTimer = window.setTimeout(() => syncCurrentCart(), 80);
    return null;
  };
  const dispatchCartEvent = (name, detail) => {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  };
  const showToast = (cart, product, variant, action = 'add', errorMessage = '') => {
    const toast = document.querySelector('[data-vnm-cart-toast]');
    if (!toast) return;
    const toastProduct = toast.querySelector('[data-vnm-cart-toast-product]');
    const toastMessage = toast.querySelector('[data-vnm-cart-toast-message]');
    const toastShipping = toast.querySelector('[data-vnm-cart-toast-shipping]');
    const toastProgressWrap = toast.querySelector('[data-vnm-cart-toast-progress-wrap]');
    const toastProgress = toast.querySelector('[data-vnm-cart-toast-progress]');
    const selectedOptions = optionText(variant);
    const money = (cents) => `€${(Number(cents || 0) / 100).toFixed(2).replace('.', ',')}`;
    if (toastProduct) toastProduct.textContent = product.title + (selectedOptions ? ` · ${selectedOptions}` : '');
    if (toastMessage) {
      if (action === 'error') toastMessage.textContent = errorMessage || toast.dataset.errorLabel || labels.error;
      else if (action === 'increase') toastMessage.textContent = toast.dataset.increasedLabel || '1 item toegevoegd aan je winkelwagen';
      else if (action === 'decrease') toastMessage.textContent = toast.dataset.decreasedLabel || '1 item verwijderd uit je winkelwagen';
      else if (action === 'remove') toastMessage.textContent = toast.dataset.removedLabel || 'Item verwijderd uit je winkelwagen';
      else toastMessage.textContent = toast.dataset.addedLabel || labels.addedToCart;
    }
    const minimum = Number(toast.dataset.freeShippingMinimum || 0);
    const total = Number(cart?.total_price || 0);
    if (minimum > 0 && cart) {
      const progress = Math.min(100, (total / minimum) * 100);
      const reached = total >= minimum;
      const deficitPattern = toast.dataset.freeShippingDeficitLabel || 'Nog __AMOUNT__ voor gratis verzending';
      if (toastShipping) {
        toastShipping.hidden = false;
        toastShipping.textContent = reached
          ? (toast.dataset.freeShippingLabel || 'Gratis verzending!')
          : deficitPattern.replace('__AMOUNT__', money(minimum - total));
      }
      toast.dataset.freeShippingReached = reached ? 'true' : 'false';
      if (toastProgressWrap && toastProgress) {
        toastProgressWrap.hidden = false;
        toastProgress.style.setProperty('--vnm-toast-progress', `${progress}%`);
      }
    } else {
      if (toastShipping) toastShipping.hidden = true;
      if (toastProgressWrap) toastProgressWrap.hidden = true;
      toast.removeAttribute('data-free-shipping-reached');
    }
    window.clearTimeout(toastTimer);
    toast.hidden = false;
    toast.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => toast.classList.add('is-visible'));
    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
      window.setTimeout(() => {
        if (!toast.classList.contains('is-visible')) toast.hidden = true;
      }, 240);
    }, 4200);
  };
  const setPending = (row, pending) => {
    if (pending) row.dataset.vnmRecommendationPending = 'true';
    else delete row.dataset.vnmRecommendationPending;
    row.querySelectorAll('[data-vnm-recommendation-mobile-add], [data-vnm-recommendation-increase], [data-vnm-recommendation-remove]').forEach((button) => {
      button.disabled = pending;
    });
  };
  const addItem = async (row, product, variant, quantity) => {
    if (row.dataset.vnmRecommendationPending === 'true') return null;
    if (!variant?.available) throw new Error(labels.soldOut);
    setPending(row, true);
    try {
      const before = await loadCart();
      const response = await fetch(silentUrl(routes().cartAdd), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: Number(variant.id), quantity }],
          sections: 'cart-icon-bubble',
          sections_url: window.location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || labels.error);
      updateCartIcon(data);
      const cart = await loadCart();
      const oldItem = cartItem(before, row);
      row.dataset.variantId = String(variant.id);
      row.dataset.vnmRecommendationOptionText = optionText(variant);
      syncRows(cart);
      refreshQikify();
      dispatchCartEvent(oldItem ? 'on:line-item:change' : 'on:cart:add', {
        cart,
        variantId: Number(variant.id),
        oldQuantity: oldItem?.quantity || 0,
        newQuantity: cartItem(cart, row)?.quantity || quantity
      });
      showToast(cart, product, variant);
      return cart;
    } finally {
      setPending(row, false);
    }
  };
  const changeItemQuantity = async (row, product, variant, quantity, action) => {
    if (row.dataset.vnmRecommendationPending === 'true') return null;
    setPending(row, true);
    try {
      const before = await loadCart();
      const oldItem = cartItem(before, row);
      if (!oldItem) return null;
      const response = await fetch(silentUrl(routes().cartChange), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: oldItem.key,
          quantity,
          sections: 'cart-icon-bubble',
          sections_url: window.location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || labels.error);
      updateCartIcon(data);
      syncRows(data);
      refreshQikify();
      dispatchCartEvent('on:line-item:change', {
        cart: data,
        variantId: Number(variant.id),
        oldQuantity: oldItem.quantity,
        newQuantity: quantity
      });
      const toastAction = action || (quantity > oldItem.quantity ? 'increase' : quantity > 0 ? 'decrease' : 'remove');
      showToast(data, product, variant, toastAction);
      return data;
    } finally {
      setPending(row, false);
    }
  };
  const optionNames = (product, variants) => {
    const source = Array.isArray(product.options) ? product.options : [];
    if (source.length) return source.map((option, index) => typeof option === 'string' ? option : option.name || `Optie ${index + 1}`);
    return optionValues(variants[0] || {}).map((_, index) => `Optie ${index + 1}`);
  };
  const createSheet = (row, product) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const names = optionNames(product, variants);
    const values = names.map((_, index) => [...new Set(variants.map((variant) => optionValues(variant)[index]).filter(Boolean))]);
    const defaultVariant = variants.find((variant) => variant?.id && variant.available);
    const selected = names.map((_, index) => optionValues(defaultVariant || {})[index] || null);
    const overlay = document.createElement('div');
    const titleId = `vnm-recommendation-title-${Date.now()}`;
    overlay.className = 'vnm-recommendation-sheet';
    overlay.innerHTML = `<section class="vnm-recommendation-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="${titleId}"><div class="vnm-recommendation-sheet__handle" aria-hidden="true"></div><header class="vnm-recommendation-sheet__header"><div class="vnm-recommendation-sheet__product"><a class="vnm-recommendation-sheet__product-link vnm-recommendation-sheet__image" target="_self"></a><div class="vnm-recommendation-sheet__product-copy"><span class="vnm-recommendation-sheet__vendor"></span><a id="${titleId}" class="vnm-recommendation-sheet__product-link vnm-recommendation-sheet__title" target="_self"></a><span class="vnm-recommendation-sheet__price"></span></div></div><button type="button" class="vnm-recommendation-sheet__close" aria-label="${labels.close}">×</button></header><div class="vnm-recommendation-sheet__body"><div class="vnm-recommendation-sheet__options"></div><p class="vnm-recommendation-sheet__availability" role="status" hidden></p></div><footer class="vnm-recommendation-sheet__footer"><div class="vnm-recommendation-sheet__benefits" hidden><span><b aria-hidden="true">✓</b>Op voorraad</span><span><b aria-hidden="true">✓</b>Gratis verzending vanaf €50</span></div><button type="button" class="vnm-recommendation-sheet__add" disabled></button></footer></section>`;
    const panel = overlay.querySelector('.vnm-recommendation-sheet__panel');
    const closeButton = overlay.querySelector('.vnm-recommendation-sheet__close');
    const imageWrap = overlay.querySelector('.vnm-recommendation-sheet__image');
    const title = overlay.querySelector('.vnm-recommendation-sheet__title');
    const price = overlay.querySelector('.vnm-recommendation-sheet__price');
    const vendor = overlay.querySelector('.vnm-recommendation-sheet__vendor');
    const productLinks = overlay.querySelectorAll('.vnm-recommendation-sheet__product-link');
    const choices = overlay.querySelector('.vnm-recommendation-sheet__options');
    const availability = overlay.querySelector('.vnm-recommendation-sheet__availability');
    const benefits = overlay.querySelector('.vnm-recommendation-sheet__benefits');
    const addButton = overlay.querySelector('.vnm-recommendation-sheet__add');
    const productMeta = document.createElement('div');
    productMeta.className = 'vnm-recommendation-sheet__meta';
    const priceValue = document.createElement('span');
    priceValue.className = 'vnm-recommendation-sheet__meta-price';
    const metaSeparator = document.createElement('span');
    metaSeparator.className = 'vnm-recommendation-sheet__meta-separator';
    metaSeparator.setAttribute('aria-hidden', 'true');
    metaSeparator.textContent = '·';
    const variantMeta = document.createElement('span');
    variantMeta.className = 'vnm-recommendation-sheet__meta-details';
    productMeta.append(priceValue, metaSeparator, variantMeta);
    price.replaceWith(productMeta);
    benefits.innerHTML = '<span><b aria-hidden="true">✓</b>Op voorraad</span><span class="vnm-recommendation-sheet__benefit-separator" aria-hidden="true">·</span><span><b aria-hidden="true">✓</b>Gratis verzending vanaf €50</span>';
    const rowImage = row.querySelector('.vnm-recommendation-row__media img');
    const imageSource = rowImage?.currentSrc
      || rowImage?.getAttribute('src')
      || product.featured_image?.src
      || product.images?.[0]
      || product.image
      || '';
    let close;

    title.textContent = product.title;
    title.style.setProperty('color', '#000000', 'important');
    title.style.setProperty('-webkit-text-fill-color', '#000000', 'important');
    title.style.setProperty('opacity', '1', 'important');
    vendor.textContent = product.vendor || '';
    vendor.hidden = !product.vendor;
    if (product.url) {
      productLinks.forEach((link) => {
        link.href = product.url;
        link.setAttribute('aria-label', product.title);
      });
    } else {
      productLinks.forEach((link) => {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
      });
    }
    addButton.textContent = 'Toevoegen aan winkelwagen';
    const imageUrl = (image) => {
      if (!image) return '';
      if (typeof image === 'string') return image;
      return image.src
        || image.url
        || image.preview_image?.src
        || image.preview_image?.url
        || image.previewImage?.src
        || image.previewImage?.url
        || '';
    };
    const setSheetImage = (source) => {
      const resolvedSource = imageUrl(source);
      if (!resolvedSource) return;
      let image = imageWrap.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.alt = '';
        image.loading = 'eager';
        image.decoding = 'sync';
        image.className = '';
        image.style.setProperty('opacity', '1', 'important');
        image.style.setProperty('filter', 'none', 'important');
        image.style.setProperty('mix-blend-mode', 'normal', 'important');
        imageWrap.replaceChildren(image);
      }
      if (image.dataset.vnmRecommendationImage !== resolvedSource) {
        image.dataset.vnmRecommendationImage = resolvedSource;
        image.src = resolvedSource;
      }
    };
    const variantImageUrl = (variant) => imageUrl(variant?.featured_image)
      || imageUrl(variant?.featured_media)
      || imageUrl(variant?.image);
    const flavorIndex = names.findIndex((name) => /smaak|flavou?r/i.test(String(name || '')));
    const variantImageSource = (variant) => {
      const directImage = variantImageUrl(variant);
      if (directImage) return directImage;
      const selectedFlavor = flavorIndex >= 0 ? selected[flavorIndex] : '';
      const matchingFlavorVariant = selectedFlavor
        ? variants.find((candidate) => optionValues(candidate)[flavorIndex] === selectedFlavor && variantImageUrl(candidate))
        : null;
      return variantImageUrl(matchingFlavorVariant) || imageSource;
    };
    setSheetImage(imageSource);

    const normalizeMeta = (value) => String(value || '')
      .replace(/\bgrams?\b/gi, 'g')
      .replace(/\bservings?\b/gi, 'servings')
      .replace(/\bporties?\b/gi, 'servings')
      .trim();
    const weightPattern = /\b\d+(?:[.,]\d+)?\s*(?:g|kg|ml|l)\b/i;
    const servingPattern = /\b\d+(?:[.,]\d+)?\s*(?:servings?|porties?)\b/i;
    const formatVariantWeight = (variant) => {
      const weight = Number(variant?.weight);
      if (!Number.isFinite(weight) || weight <= 0) return '';
      const unit = String(variant?.weight_unit || 'g').toLowerCase();
      if (unit === 'g' && weight >= 1000 && weight % 1000 === 0) return (weight / 1000) + ' kg';
      return (String(weight).replace(/\.0+$/, '')) + ' ' + unit;
    };
    const variantDetails = (variant) => {
      const values = optionValues(variant).map(normalizeMeta);
      const titleValues = String(variant?.title || '').split(/\s*\/\s*/).map(normalizeMeta);
      const allValues = [formatVariantWeight(variant), ...values, ...titleValues].filter(Boolean);
      const weight = allValues.find((value) => weightPattern.test(value));
      const servings = allValues.find((value) => servingPattern.test(value));
      return [weight, servings].filter(Boolean).join(' · ');
    };
    const choiceDetails = (index, value) => {
      const current = normalizeMeta(value);
      if (!weightPattern.test(current) && !servingPattern.test(current)) return { primary: current, secondary: '' };
      const matching = variants.find((variant) => optionValues(variant)[index] === value && variant.available)
        || variants.find((variant) => optionValues(variant)[index] === value);
      const details = variantDetails(matching || {});
      const [weight, servings] = details.split(' · ');
      return {
        primary: weight || current,
        secondary: servings || ''
      };
    };
    const findVariant = () => {
      if (selected.some((value) => !value)) return null;
      return variants.find((variant) => optionValues(variant).every((value, index) => value === selected[index]));
    };
    const canChoose = (index, value) => variants.some((variant) => {
      if (!variant.available || optionValues(variant)[index] !== value) return false;
      return selected.every((selectedValue, selectedIndex) => selectedIndex === index || !selectedValue || optionValues(variant)[selectedIndex] === selectedValue);
    });
    const render = () => {
      choices.querySelectorAll('[data-vnm-sheet-option]').forEach((button) => {
        const index = Number(button.dataset.vnmSheetOptionIndex);
        const value = button.dataset.vnmSheetOption;
        const active = selected[index] === value;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        button.disabled = !canChoose(index, value);
      });
      const variant = findVariant();
      setSheetImage(variantImageSource(variant));
      if (variant) {
        const details = variantDetails(variant);
        priceValue.textContent = formatMoney(variant.price);
        variantMeta.textContent = details;
        variantMeta.hidden = !details;
        metaSeparator.hidden = !details;
        addButton.textContent = 'Toevoegen aan winkelwagen';
        availability.hidden = variant.available;
        availability.textContent = variant.available ? '' : labels.soldOut;
        availability.classList.toggle('is-in-stock', variant.available);
        availability.classList.toggle('is-unavailable', !variant.available);
      } else {
        const fallbackPrice = product.price || variants[0]?.price || 0;
        priceValue.textContent = formatMoney(fallbackPrice);
        variantMeta.textContent = '';
        variantMeta.hidden = true;
        metaSeparator.hidden = true;
        addButton.textContent = 'Selecteer een variant';
        availability.hidden = true;
        availability.textContent = '';
        availability.classList.remove('is-in-stock', 'is-unavailable');
      }
      const valid = Boolean(variant?.available);
      addButton.disabled = !valid;
      benefits.hidden = !valid;
    };

    names.forEach((name, index) => {
      const selectableValues = values[index].filter((value) => variants.some((variant) => variant.available && optionValues(variant)[index] === value));
      if (names.length > 1 && selectableValues.length <= 1) return;
      const group = document.createElement('fieldset');
      const legend = document.createElement('legend');
      const list = document.createElement('div');
      legend.textContent = names.length === 1 ? 'Kies inhoud' : name;
      list.className = 'vnm-recommendation-sheet__choice-list';
      selectableValues.forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.vnmSheetOption = value;
        button.dataset.vnmSheetOptionIndex = String(index);
        const display = choiceDetails(index, value);
        const primary = document.createElement('span');
        primary.className = 'vnm-recommendation-sheet__choice-primary';
        primary.textContent = display.primary;
        button.append(primary);
        if (display.secondary) {
          const secondary = document.createElement('span');
          secondary.className = 'vnm-recommendation-sheet__choice-secondary';
          secondary.textContent = display.secondary;
          button.append(secondary);
        }
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => {
          selected[index] = value;
          render();
        });
        list.append(button);
      });
      group.append(legend, list);
      choices.append(group);
    });

    close = () => {
      if (activeSheet !== overlay) return;
      activeSheet = undefined;
      document.body.classList.remove('vnm-recommendation-sheet-open');
      document.removeEventListener('keydown', handleKeydown);
      overlay.remove();
      row.querySelector('[data-vnm-recommendation-mobile-add]')?.focus();
    };
    const handleKeydown = (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(overlay.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) close();
    });
    addButton.addEventListener('click', async () => {
      const variant = findVariant();
      if (!variant?.available) return;
      addButton.disabled = true;
      panel.classList.add('is-loading');
      try {
        await addItem(row, product, variant, 1);
        close();
      } catch (error) {
        availability.textContent = error.message || labels.error;
        availability.classList.add('is-unavailable');
      } finally {
        if (activeSheet === overlay) {
          panel.classList.remove('is-loading');
          render();
        }
      }
    });

    if (activeSheet) activeSheet.querySelector('.vnm-recommendation-sheet__close')?.click();
    activeSheet = overlay;
    document.body.append(overlay);
    document.body.classList.add('vnm-recommendation-sheet-open');
    document.addEventListener('keydown', handleKeydown);
    render();
    closeButton.focus();
  };
  const handleMobileClick = async (event) => {
    if (!mobileMedia.matches) return;
    const button = event.target.closest('[data-vnm-recommendation-mobile-add]');
    if (button) {
      event.preventDefault();
      const row = button.closest(rowSelector);
      const product = row && getProduct(row);
      const variants = product?.variants || [];
      if (!row || !product || row.dataset.vnmRecommendationPending === 'true') return;
      if (!variants.length) {
        showToast(null, product, {}, 'error', labels.error);
        return;
      }
      if (variants.length === 1) {
        try {
          await addItem(row, product, variants[0], 1);
        } catch (error) {
          showToast(null, product, variants[0], 'error', error.message || labels.error);
        }
      } else {
        createSheet(row, product);
      }
      return;
    }
    const increase = event.target.closest('[data-vnm-recommendation-increase]');
    const remove = event.target.closest('[data-vnm-recommendation-remove]');
    if (!increase && !remove) return;
    event.preventDefault();
    const row = (increase || remove).closest(rowSelector);
    const product = row && getProduct(row);
    const variant = product?.variants?.find((item) => Number(item.id) === Number(row.dataset.variantId));
    if (!row || !product || !variant) return;
    try {
      if (increase) {
        await addItem(row, product, variant, 1);
      } else {
        const currentQuantity = Math.max(1, Number(row.querySelector('[data-vnm-recommendation-quantity]')?.textContent) || 1);
        const nextQuantity = currentQuantity - 1;
        await changeItemQuantity(row, product, variant, nextQuantity, nextQuantity > 0 ? 'decrease' : 'remove');
      }
    } catch (error) {
      showToast(null, product, variant, 'error', error.message || labels.error);
    }
  };
  const syncInitialCart = async () => {
    await syncCurrentCart();
  };

  document.addEventListener('click', handleMobileClick);
  window.addEventListener('pageshow', syncInitialCart);
  mobileMedia.addEventListener?.('change', () => scheduleCartSync(true));
  ['on:cart:add', 'on:line-item:change', 'cart:updated', 'cart:refresh', 'shopify:section:load'].forEach((eventName) => {
    document.addEventListener(eventName, () => scheduleCartSync(true));
  });
  if (document.body) {
    const recommendationObserver = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => (
        node.nodeType === Node.ELEMENT_NODE && (node.matches?.(rowSelector) || node.querySelector?.(rowSelector))
      )))) scheduleCartSync();
    });
    recommendationObserver.observe(document.body, { childList: true, subtree: true });
  }
  syncInitialCart();
})();
